/**
 * Ciclo de vida de una alarma: activa → reconocida → resuelta.
 * Una alarma "abierta" es la que todavía exige seguimiento (activa o reconocida).
 */

export const ESTADOS_ALARMA = ['activa', 'reconocida', 'resuelta'] as const;
export type EstadoAlarmaValor = (typeof ESTADOS_ALARMA)[number];

const ETIQUETA: Readonly<Record<EstadoAlarmaValor, string>> = {
  activa: 'Activa',
  reconocida: 'Reconocida',
  resuelta: 'Resuelta',
};

const TOKEN: Readonly<Record<EstadoAlarmaValor, string>> = {
  activa: '--status-danger',
  reconocida: '--status-warning',
  resuelta: '--status-success',
};

export class EstadoAlarma {
  private constructor(readonly valor: EstadoAlarmaValor) {}

  static from(raw: string | null | undefined): EstadoAlarma {
    const limpio = (raw ?? '').trim().toLowerCase();
    const valor = (ESTADOS_ALARMA as readonly string[]).includes(limpio)
      ? (limpio as EstadoAlarmaValor)
      : 'activa';
    return new EstadoAlarma(valor);
  }

  get etiqueta(): string {
    return ETIQUETA[this.valor];
  }

  get color(): string {
    return `var(${TOKEN[this.valor]})`;
  }

  get esActiva(): boolean {
    return this.valor === 'activa';
  }

  get esReconocida(): boolean {
    return this.valor === 'reconocida';
  }

  get esResuelta(): boolean {
    return this.valor === 'resuelta';
  }

  /** Sigue exigiendo seguimiento del operador. */
  get estaAbierta(): boolean {
    return !this.esResuelta;
  }

  toString(): string {
    return this.valor;
  }
}
